// USERS
export const READ_USERS = 'READ_USERS';
export const WRITE_USERS = 'WRITE_USERS';
// END USERS
// PROPOSAL PROJECT
export const ADMIN_PROPOSAL_PROJECT = 'ADMIN_PROPOSAL_PROJECT';
export const USER_PROPOSAL_PROJECT = 'USER_PROPOSAL_PROJECT';
export const OWNER_PROPOSAL_PROJECT = 'OWNER_PROPOSAL_PROJECT';
// END PROPOSAL PROJECT
// CS
export const ADMIN_CS = 'ADMIN_CS';
// END CS
// IMPROVEMENT PROPOSAL
export const ADMIN_IMPROVEMENT_PROPOSAL = 'ADMIN_IMPROVEMENT_PROPOSAL';
//DELEGACIONES DE SERVICIOS
export const GESTOR_DELEGACIONES_SERVICIOS = 'GESTOR_DELEGACIONES_SERVICIOS';
export const DELEGADO_DELEGACIONES_SERVICIOS = 'DELEGADO_DELEGACIONES_SERVICIOS';
//END DELEGACIONES DE SERVICIOS
// EXTRAS
export const EXTRAS_EMPLOYE = 'EXTRAS_EMPLOYE';
export const EXTRAS_VALIDATOR = 'EXTRAS_VALIDATOR';
export const EXTRAS = 'EXTRAS';
// END EXTRAS
// ORGCHART
export const ADMIN_ORGCHART = 'ADMIN_ORGCHART';
export const ORGCHART = 'ORGCHART';
// END ORGCHART